(function () {
  'use strict';

  if (window.__smart360BehaviorEventsBound) return;
  window.__smart360BehaviorEventsBound = true;

  var EVENT_VERSION = '1.5.0';
  var GA4_MEASUREMENT_ID = 'G-7N14QPXFEW';
  var DEDUPE_WINDOW_MS = 750;
  var SECTION_VIEW_MIN_MS = 1000;
  var CARD_VIEW_MIN_MS = 1000;
  var CARD_VIEW_MIN_RATIO = 0.5;
  var SCROLL_MILESTONES = [25, 50, 75, 90, 100];
  var recentEvents = {};
  var interactionSequence = 0;
  var pageStartedAt = Date.now();

  if (window.performance && typeof window.performance.timeOrigin === 'number') {
    pageStartedAt = Math.round(window.performance.timeOrigin);
  }

  window.__smart360BehaviorEvents = window.__smart360BehaviorEvents || [];

  function isPreview() {
    try {
      return new URLSearchParams(window.location.search).has('preview_theme_id') ||
        !!(window.Shopify && window.Shopify.designMode) ||
        !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
    } catch (error) {
      return false;
    }
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function normalizeKey(value) {
    return cleanText(value)
      .toLowerCase()
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 100);
  }

  function normalizeVariantTitle(value) {
    return cleanText(value)
      .toLowerCase()
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ');
  }

  function cleanObject(value) {
    if (Array.isArray(value)) {
      return value.map(cleanObject).filter(function (item) {
        return item !== undefined;
      });
    }

    if (value && typeof value === 'object') {
      var output = {};
      Object.keys(value).forEach(function (key) {
        var next = cleanObject(value[key]);
        if (next !== undefined && next !== null && next !== '') output[key] = next;
      });
      return output;
    }

    if (typeof value === 'string') return cleanText(value);
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    return undefined;
  }

  function pageType() {
    var path = window.location.pathname;
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/search') === 0) return 'search';
    if (path.indexOf('/cart') === 0) return 'cart';
    return 'page';
  }

  function currency() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var node = document.querySelector('meta[property="og:price:currency"]');
    return cleanText(
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (meta && meta.currency) ||
      (node && node.content) ||
      'USD'
    );
  }

  function productData() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta && meta.product ? meta.product : null;
  }

  function productTitle() {
    var heading = document.querySelector('main h1, article h1, h1');
    return cleanText(heading && heading.textContent);
  }

  function findVariant(product, preferredTitle, preferredId) {
    if (!product || !Array.isArray(product.variants)) return null;

    var title = normalizeVariantTitle(preferredTitle);
    var id = cleanText(preferredId);
    var variant = null;

    product.variants.some(function (candidate) {
      var matchesId = id && String(candidate.id) === id;
      var matchesTitle = title && normalizeVariantTitle(candidate.public_title) === title;
      if (matchesId || matchesTitle) {
        variant = candidate;
        return true;
      }
      return false;
    });

    return variant;
  }

  function selectedVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;

    var selectedPill = document.querySelector('[data-smart-variant-pill][aria-pressed="true"]');
    var pillTitle = selectedPill && selectedPill.getAttribute('data-option-value');
    var fromPill = findVariant(product, pillTitle, '');
    if (fromPill) return fromPill;

    var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < inputs.length; i += 1) {
      var fromInput = findVariant(product, '', inputs[i].value);
      if (fromInput) return fromInput;
    }

    return product.variants.length === 1 ? product.variants[0] : null;
  }

  function productPayload(preferredTitle, preferredId) {
    var product = productData();
    if (!product) return {};

    var variant = findVariant(product, preferredTitle, preferredId) || selectedVariant(product);
    return cleanObject({
      product_id: String(product.id || ''),
      item_id: variant ? String(variant.id || '') : '',
      variant_id: variant ? String(variant.id || '') : '',
      item_name: productTitle() || (variant && variant.name),
      item_variant: variant && variant.public_title,
      item_sku: variant && variant.sku,
      item_sku_status: variant ? (variant.sku ? 'present' : 'missing_source') : 'unresolved_variant',
      price: variant && typeof variant.price === 'number' ? variant.price / 100 : undefined,
      currency: currency()
    });
  }

  function eventId() {
    return 's360-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function duplicateWithinWindow(name, key) {
    if (!key) return false;

    var now = Date.now();
    var fingerprint = name + ':' + window.location.pathname + ':' + cleanText(key);
    if (recentEvents[fingerprint] && now - recentEvents[fingerprint] < DEDUPE_WINDOW_MS) return true;
    recentEvents[fingerprint] = now;

    window.setTimeout(function () {
      if (recentEvents[fingerprint] === now) delete recentEvents[fingerprint];
    }, DEDUPE_WINDOW_MS * 2);

    return false;
  }

  function pageElapsedMs() {
    if (window.performance && typeof window.performance.now === 'function') {
      return Math.max(0, Math.round(window.performance.now()));
    }
    return Math.max(0, Date.now() - pageStartedAt);
  }

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return true;

    try {
      return privacy.analyticsProcessingAllowed();
    } catch (error) {
      return false;
    }
  }

  function emit(name, values, dedupeKey) {
    if (duplicateWithinWindow(name, dedupeKey)) return;

    interactionSequence += 1;

    var payload = cleanObject(Object.assign({
      event_id: eventId(),
      event_version: EVENT_VERSION,
      event_source: 'smart360_theme',
      page_type: pageType(),
      page_elapsed_ms: pageElapsedMs(),
      interaction_sequence: interactionSequence
    }, values || {}));

    var record = {
      name: name,
      payload: payload,
      timestamp: new Date().toISOString(),
      preview: isPreview(),
      analytics_allowed: analyticsAllowed(),
      page_path: window.location.pathname,
      page_title: document.title
    };

    window.__smart360BehaviorEvents.push(record);

    try {
      document.dispatchEvent(new CustomEvent('smart360:behavior-event', { detail: record }));
    } catch (error) {
      // Older browsers can still deliver the GA4 event.
    }

    if (isPreview()) {
      if (window.console && console.info) console.info('[Smart360 behavior preview]', record);
      return;
    }

    if (!record.analytics_allowed) {
      if (window.console && console.info) console.info('[Smart360 behavior] Blocked by analytics consent:', name);
      return;
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, Object.assign({ send_to: GA4_MEASUREMENT_ID }, payload));
    } else if (window.console && console.warn) {
      console.warn('[Smart360 behavior] Google tag was not available for', name);
    }
  }

  function eventPath(event) {
    if (event.composedPath) return event.composedPath();

    var path = [];
    var node = event.target;
    while (node) {
      path.push(node);
      node = node.parentNode;
    }
    path.push(window);
    return path;
  }

  function firstInPath(path, test) {
    for (var i = 0; i < path.length; i += 1) {
      var node = path[i];
      if (node && node.nodeType === 1 && test(node)) return node;
    }
    return null;
  }

  function closestFromPath(path, selector) {
    return firstInPath(path, function (node) {
      return node.matches && node.matches(selector);
    });
  }

  function productHandleFromUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/^\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  function collectionCardFromPath(path) {
    return closestFromPath(path, '#CollectionProductGrid [data-smart-track-card="true"]');
  }

  function cardItem(card) {
    if (!card) return {};

    var productId = cleanText(card.getAttribute('data-smart-product-id'));
    var variantId = cleanText(card.getAttribute('data-smart-variant-id'));
    var rawPrice = Number(card.getAttribute('data-smart-item-price-cents'));
    var rawIndex = Number(card.getAttribute('data-smart-item-index'));

    return cleanObject({
      item_id: variantId || productId,
      item_name: card.getAttribute('data-smart-item-name'),
      item_brand: card.getAttribute('data-smart-item-brand'),
      item_category: card.getAttribute('data-smart-item-category'),
      item_variant: card.getAttribute('data-smart-item-variant'),
      item_list_id: card.getAttribute('data-smart-item-list-id'),
      item_list_name: card.getAttribute('data-smart-item-list-name'),
      index: isFinite(rawIndex) ? rawIndex : undefined,
      price: isFinite(rawPrice) && rawPrice > 0 ? rawPrice / 100 : undefined,
      product_id: productId,
      variant_id: variantId,
      item_sku: card.getAttribute('data-smart-item-sku')
    });
  }

  function cardEventPayload(card, values) {
    var item = cardItem(card);
    var index = typeof item.index === 'number' ? item.index : undefined;

    return cleanObject(Object.assign({
      currency: currency(),
      value: item.price,
      item_id: item.item_id,
      item_name: item.item_name,
      item_brand: item.item_brand,
      item_category: item.item_category,
      item_variant: item.item_variant,
      item_list_id: item.item_list_id,
      item_list_name: item.item_list_name,
      item_index: index,
      card_position: typeof index === 'number' ? index + 1 : undefined,
      product_id: item.product_id,
      variant_id: item.variant_id,
      item_sku: item.item_sku,
      items: [item]
    }, values || {}));
  }

  function handleSelectItem(path) {
    if (pageType() !== 'collection' && pageType() !== 'search') return;

    var card = collectionCardFromPath(path);
    var link = closestFromPath(path, 'a[href*="/products/"]');
    if (!card || !link || !card.contains(link)) return;

    var handle = productHandleFromUrl(link.href);
    if (!handle) return;

    var item = cardItem(card);
    if (!item.item_id) return;

    emit('select_item', cardEventPayload(card, {
      interaction_type: 'product_card_click',
      destination_path: new URL(link.href, window.location.origin).pathname
    }), item.item_id + ':' + item.index);
  }

  function emitCollectionQuickAdd(form) {
    if (!form || pageType() !== 'collection') return;

    var card = form.closest('#CollectionProductGrid [data-smart-track-card="true"]');
    if (!card) return;

    var item = cardItem(card);
    if (!item.item_id) return;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Number(quantityInput && quantityInput.value) || 1;

    emit('collection_quick_add_click', cardEventPayload(card, {
      interaction_type: 'quick_add',
      quantity: Math.max(1, quantity)
    }), item.item_id + ':' + item.index);
  }

  function handleCollectionQuickAdd(path) {
    var trigger = closestFromPath(path, 'button[type="submit"], input[type="submit"], button[name="add"]');
    if (!trigger) return;

    var form = trigger.closest('form[action*="/cart/add"]');
    emitCollectionQuickAdd(form);
  }

  function handleCollectionQuickAddSubmit(event) {
    if (!event.isTrusted) return;
    emitCollectionQuickAdd(event.target);
  }

  function handleVariant(path) {
    var pill = closestFromPath(path, '[data-smart-variant-pill]');
    if (!pill) return;
    if (pill.getAttribute('aria-pressed') === 'true') return;

    var option = pill.getAttribute('data-option-value') || pill.textContent;
    var product = productData();
    var variant = findVariant(product, option, '');

    emit('variant_select', Object.assign({
      selection_ui: 'pill'
    }, productPayload(option, variant && variant.id)), (variant && variant.id) || option);
  }

  function handleVariantChange(event) {
    if (!event.isTrusted || pageType() !== 'product') return;

    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('select[data-option-selector], [data-smart-variant-option] select, x-variant-picker select, x-variant-picker input, #sticky-cart select')) return;

    window.setTimeout(function () {
      var option = target.options && target.selectedIndex >= 0
        ? target.options[target.selectedIndex].text
        : target.value;
      var product = productData();
      var variant = findVariant(product, option, '') || selectedVariant(product);

      emit('variant_select', Object.assign({
        selection_ui: target.closest('#sticky-cart') ? 'sticky_select' : 'select'
      }, productPayload(option, variant && variant.id)), (variant && variant.id) || option);
    }, 0);
  }

  function classifyMedia(text) {
    var value = cleanText(text).toLowerCase();
    if (/flight.?case|air.?case|carrying.?case/.test(value)) return 'flight_case';
    if (/23\.6|31\.5|39\.4|45\.3|60cm|80cm|100cm|115cm|people|person|size/.test(value)) return 'size_usage';
    if (/light|rgb|led/.test(value)) return 'lighting';
    if (/compatib|device|phone|camera|ipad/.test(value)) return 'compatibility';
    if (/adjust|angle|arm|point/.test(value)) return 'adjustable_design';
    if (/feature|mode|control/.test(value)) return 'feature';
    return 'product_image';
  }

  function emitGalleryFromImage(image, interaction) {
    if (!image || pageType() !== 'product') return;

    var source = image.getAttribute('data-src-master') || image.currentSrc || image.src || '';
    var mediaId = image.getAttribute('data-media-id') ||
      (image.closest('[data-media-id]') && image.closest('[data-media-id]').getAttribute('data-media-id')) ||
      source.split('/').pop().split('?')[0];
    var label = cleanText(image.alt || source.split('/').pop());

    emit('gallery_view', Object.assign({
      media_id: mediaId,
      media_name: label,
      media_type: classifyMedia(label + ' ' + source),
      interaction_type: interaction
    }, productPayload()), mediaId);
  }

  function activeGalleryImage() {
    return document.querySelector(
      'article.product-detail .primary-media-container.active img, ' +
      '.secondary-media-types .secondary-media-container.active img, ' +
      '.swiper-slide-active img[data-media-id], ' +
      '.swiper-slide-active img'
    );
  }

  function handleGallery(path) {
    if (pageType() !== 'product') return;

    var mediaLink = closestFromPath(path, 'a[href*="/cdn/shop/files/"]');
    if (mediaLink) {
      emitGalleryFromImage(mediaLink.querySelector('img') || closestFromPath(path, 'img'), 'thumbnail_or_image');
      return;
    }

    var control = closestFromPath(path, 'button[aria-label*="product image" i]');
    if (control) {
      window.setTimeout(function () {
        emitGalleryFromImage(activeGalleryImage(), 'gallery_control');
      }, 250);
    }
  }

  function handleProductVideo(path) {
    if (pageType() !== 'product') return;

    var control = closestFromPath(path, '[data-smart-gallery-youtube-id], [data-smart-youtube-id]');
    if (!control) return;

    var videoId = cleanText(
      control.getAttribute('data-smart-gallery-youtube-id') ||
      control.getAttribute('data-smart-youtube-id')
    );
    if (!videoId) return;

    var surface = control.hasAttribute('data-smart-gallery-youtube-id') ? 'gallery' : 'product_details';
    emit('product_video_click', Object.assign({
      video_id: videoId,
      video_title: cleanText(control.getAttribute('data-video-title') || control.getAttribute('aria-label')),
      video_surface: surface
    }, productPayload()), surface + ':' + videoId);
  }

  function handleProductDetailNavigation(path) {
    if (pageType() !== 'product') return;

    var link = closestFromPath(path, '[data-smart-pdp-anchor]');
    if (!link) return;

    var target = cleanText(link.getAttribute('href')).replace(/^#/, '');
    emit('product_detail_nav_click', Object.assign({
      navigation_target: target,
      interaction_label: cleanText(link.textContent || link.getAttribute('aria-label'))
    }, productPayload()), target);
  }

  function ctaSurface(control) {
    if (control.closest('[data-smart-sticky-add-to-cart]')) return 'sticky_panel';
    if (control.closest('[data-smart-sticky-add-trigger]')) return 'sticky_bar';
    if (control.closest('.smart-pdp-compare-table')) return 'comparison_table';
    if (control.closest('.smart-pdp-expert-cta')) return 'expert_section';
    return 'main_purchase_panel';
  }

  function handleProductCta(path) {
    if (pageType() !== 'product') return;

    var control = closestFromPath(path,
      '[data-smart-pdp-buy-now], [data-smart-sticky-add-trigger], ' +
      '[data-smart-sticky-add-to-cart], [data-smart-pdp-add-to-cart], ' +
      '[data-smart-scroll-to-purchase]'
    );
    if (!control) return;

    var action = 'add_to_cart';
    if (control.hasAttribute('data-smart-pdp-buy-now')) action = 'buy_now';
    else if (control.hasAttribute('data-smart-sticky-add-trigger')) action = 'open_sticky_purchase';
    else if (control.hasAttribute('data-smart-scroll-to-purchase')) action = 'scroll_to_purchase';

    var surface = ctaSurface(control);
    emit('pdp_cta_click', Object.assign({
      cta_action: action,
      cta_surface: surface,
      interaction_label: cleanText(control.textContent || control.getAttribute('aria-label'))
    }, productPayload()), action + ':' + surface);
  }

  function handleProductEstimatorChange(event) {
    if (!event.isTrusted || pageType() !== 'product') return;

    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-smart-event-rate], [data-smart-events-month]')) return;

    var control = target.hasAttribute('data-smart-event-rate') ? 'event_rate' : 'events_per_month';
    var value = Number(target.value);
    emit('product_estimator_change', Object.assign({
      estimator_control: control,
      estimator_value: isFinite(value) ? value : undefined
    }, productPayload()), control + ':' + target.value);
  }

  function handleProductPurchaseSubmit(event) {
    if (!event.isTrusted || pageType() !== 'product') return;

    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var submitter = event.submitter;
    if (!submitter || !submitter.matches || !submitter.matches('[data-smart-pdp-add-to-cart], [data-smart-sticky-add-to-cart]')) return;

    var surface = ctaSurface(submitter);
    emit('pdp_cta_click', Object.assign({
      cta_action: 'add_to_cart',
      cta_surface: surface,
      interaction_label: cleanText(submitter.textContent || submitter.getAttribute('aria-label'))
    }, productPayload()), 'add_to_cart:' + surface);
  }

  function handleCartAddResult(event) {
    var detail = event && event.detail ? event.detail : {};
    var status = cleanText(detail.status);
    if (status !== 'success' && status !== 'failed') return;

    var source = detail.form || detail.trigger;
    if (!source || !source.closest) return;

    if (pageType() === 'collection') {
      var card = source.closest('#CollectionProductGrid [data-smart-track-card="true"]');
      var item = cardItem(card);
      if (!card || !item.item_id) return;

      emit('collection_quick_add_result', cardEventPayload(card, {
        result_status: status,
        result_reason: detail.errorReason,
        interaction_type: 'quick_add'
      }), status + ':' + item.item_id + ':' + item.index);
      return;
    }

    if (pageType() !== 'product') return;

    var trigger = detail.trigger;
    var surface = trigger && trigger.closest ? ctaSurface(trigger) : 'main_purchase_panel';
    emit('pdp_add_to_cart_result', Object.assign({
      result_status: status,
      result_reason: detail.errorReason,
      cta_surface: surface
    }, productPayload()), status + ':' + surface);
  }

  function handleFinancing(path) {
    var interactive = closestFromPath(path, 'a, button, [role="button"], klarna-placement');
    if (!interactive) return;

    var financingRoot = firstInPath(path, function (node) {
      var tag = cleanText(node.tagName).toLowerCase();
      var marker = cleanText(
        node.getAttribute('data-smart-financing-provider') ||
        node.getAttribute('data-financing-provider') ||
        node.id ||
        node.className
      ).toLowerCase();
      return tag === 'klarna-placement' || /klarna|paypal.*pay.*later|pay.*later|financ/.test(marker);
    });
    var explicitProvider = cleanText(
      (financingRoot && (
        financingRoot.getAttribute('data-smart-financing-provider') ||
        financingRoot.getAttribute('data-financing-provider')
      )) ||
      interactive.getAttribute('data-smart-financing-provider') ||
      interactive.getAttribute('data-financing-provider')
    ).toLowerCase();
    var ownText = cleanText([
      interactive.getAttribute('aria-label'),
      interactive.getAttribute('title'),
      interactive.getAttribute('href'),
      interactive.textContent
    ].join(' ')).toLowerCase();
    var rootText = financingRoot ? cleanText(financingRoot.textContent).toLowerCase() : '';
    var provider = '';

    if (/paypal/.test(explicitProvider) || /paypal.*pay.*later/.test(ownText + ' ' + rootText)) {
      provider = 'paypal_pay_later';
    } else if (/klarna/.test(explicitProvider) ||
      (financingRoot && cleanText(financingRoot.tagName).toLowerCase() === 'klarna-placement') ||
      /klarna|check purchase power/.test(ownText + ' ' + rootText)) {
      provider = 'klarna';
    }

    if (!provider) return;
    emit('financing_click', Object.assign({
      financing_provider: provider,
      interaction_label: cleanText(interactive.getAttribute('aria-label') || interactive.textContent),
      financing_surface: financingRoot ? cleanText(financingRoot.tagName).toLowerCase() : 'direct_control'
    }, productPayload()), provider);
  }

  function handleInfo(path) {
    var trustCard = closestFromPath(path, '[data-smart-pdp-open]');
    var summary = closestFromPath(path, 'summary');
    var tab = closestFromPath(path, '[data-smart-pdp-tab], [role="tab"]');
    var interactive = trustCard || summary || tab || closestFromPath(path, 'a, button, [role="button"]');
    if (!interactive) return;

    var label = cleanText(
      interactive.getAttribute('data-smart-pdp-title') ||
      interactive.getAttribute('aria-label') ||
      interactive.textContent
    );
    var lower = label.toLowerCase();
    var href = cleanText(interactive.href).toLowerCase();

    if (/\b(close|dismiss)\b/.test(lower)) return;

    if (summary && summary.closest('details')) {
      var details = summary.closest('details');
      var question = label;
      var topic = normalizeKey(
        summary.getAttribute('data-faq-topic') ||
        details.getAttribute('data-faq-topic') ||
        summary.getAttribute('aria-controls') ||
        question
      );

      window.setTimeout(function () {
        if (!details.open) return;
        emit('faq_open', Object.assign({
          info_topic: topic || 'faq',
          faq_question: question
        }, productPayload()), topic || question);
      }, 0);
      return;
    }

    if (pageType() !== 'product') return;

    if (tab) {
      if (tab.getAttribute('aria-selected') === 'true') return;
      emit('product_detail_tab_open', Object.assign({
        tab_name: label
      }, productPayload()), label);
      return;
    }

    if (/size guide/.test(lower)) {
      emit('size_guide_open', Object.assign({ info_topic: 'size_guide' }, productPayload()), 'size_guide');
      return;
    }

    if (/warranty/.test(lower + ' ' + href)) {
      emit('warranty_info_open', Object.assign({ info_topic: 'warranty' }, productPayload()), label || href);
      return;
    }

    if (/shipping|delivery/.test(lower + ' ' + href)) {
      emit('shipping_info_open', Object.assign({ info_topic: 'shipping' }, productPayload()), label || href);
      return;
    }

    if (/return|refund/.test(lower + ' ' + href)) {
      emit('returns_info_open', Object.assign({ info_topic: 'returns' }, productPayload()), label || href);
      return;
    }

    if (/technical support|customer support/.test(lower + ' ' + href)) {
      emit('support_info_open', Object.assign({ info_topic: 'technical_support' }, productPayload()), label || href);
      return;
    }

  }

  function handleContact(path) {
    var interactive = closestFromPath(path, 'a, button, [role="button"]');
    if (!interactive) return;

    var href = cleanText(interactive.href || interactive.getAttribute('href')).toLowerCase();
    var label = cleanText(interactive.getAttribute('aria-label') || interactive.textContent).toLowerCase();
    var channel = '';

    if (href.indexOf('mailto:') === 0) channel = 'email';
    else if (href.indexOf('tel:') === 0) channel = 'phone';
    else if (href.indexOf('sms:') === 0) channel = 'sms';
    else if (/wa\.me|whatsapp/.test(href)) channel = 'whatsapp';
    else if (/m\.me|messenger\.com/.test(href)) channel = 'messenger';
    else if (/\/pages\/contact-us/.test(href)) channel = 'contact_page';
    else if (/^chat$|open chat|live chat|chat with us/.test(label)) channel = 'chat';

    if (!channel) return;
    emit('contact_click', Object.assign({
      contact_channel: channel,
      interaction_label: label
    }, productPayload()), channel);
  }

  function trackingPayload(values) {
    return Object.assign({}, pageType() === 'product' ? productPayload() : {}, values || {});
  }

  function scrollMetrics() {
    var documentElement = document.documentElement;
    var body = document.body;
    var documentHeight = Math.max(
      documentElement ? documentElement.scrollHeight : 0,
      body ? body.scrollHeight : 0,
      documentElement ? documentElement.offsetHeight : 0,
      body ? body.offsetHeight : 0
    );
    var viewportHeight = window.innerHeight || (documentElement && documentElement.clientHeight) || 0;
    var viewportBottom = Math.max(0, window.pageYOffset || documentElement.scrollTop || 0) + viewportHeight;
    var percent = documentHeight > 0 ? Math.min(100, Math.round((viewportBottom / documentHeight) * 100)) : 0;

    if (documentHeight - viewportBottom <= 2) percent = 100;

    return {
      percent: percent,
      documentHeight: Math.round(documentHeight),
      viewportHeight: Math.round(viewportHeight)
    };
  }

  function bindScrollDepth() {
    var sentMilestones = {};
    var scheduled = false;

    function check() {
      scheduled = false;
      var metrics = scrollMetrics();

      SCROLL_MILESTONES.forEach(function (milestone) {
        if (sentMilestones[milestone] || metrics.percent < milestone) return;
        sentMilestones[milestone] = true;
        emit('scroll_depth', trackingPayload({
          percent_scrolled: milestone,
          scroll_method: 'viewport_bottom',
          document_height: metrics.documentHeight,
          viewport_height: metrics.viewportHeight
        }), String(milestone));
      });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(check);
      } else {
        window.setTimeout(check, 50);
      }
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.setTimeout(schedule, 250);
    window.addEventListener('load', schedule, { once: true });
  }

  function sectionDefinitions() {
    if (pageType() === 'collection') {
      return [
        { id: 'collection_header', name: 'Collection Header', selector: '.main-collection-product-grid .title' },
        { id: 'collection_description', name: 'Collection Description', selector: '.main-collection-product-grid .collection-description' },
        { id: 'collection_product_grid', name: 'Product Grid', selector: '#CollectionProductGrid' },
        { id: 'collection_how_it_works', name: 'How It Works', selector: '.section-smart-360-how-it-works' },
        { id: 'collection_custom_logo', name: 'Custom Logo Service', selector: '.section-smart-custom-logo-sticker' },
        { id: 'collection_faq', name: 'FAQ', selector: '.section-smart-faq' },
        { id: 'collection_trust_bar', name: 'Trust Bar', selector: '.section-smart-trust-bar' }
      ];
    }

    if (pageType() === 'product') {
      return [
        { id: 'product_gallery', name: 'Product Gallery', selector: 'article.product-detail > .row > .columns:first-child' },
        { id: 'product_purchase_panel', name: 'Product Purchase Panel', selector: 'article.product-detail > .row > .columns:nth-child(2)' },
        { id: 'product_financing', name: 'Financing', selector: 'klarna-placement, [data-smart-financing-provider], [id*="klarna_on_site_messaging"]' },
        { id: 'product_variants', name: 'Variant And Purchase Controls', selector: 'article.product-detail .variants' },
        { id: 'product_custom_logo', name: 'Custom Logo Service', selector: '.smart-pdp-custom-logo' },
        { id: 'product_delivery_estimate', name: 'Delivery Estimate', selector: '.smart-pdp-eta' },
        { id: 'product_trust', name: 'Shipping Warranty And Support', selector: '.smart-pdp-trust-grid' },
        { id: 'product_payment_delivery', name: 'Payment And Delivery', selector: '.smart-pdp-checkout-delivery' },
        { id: 'product_story_overview', name: 'Product Overview', selector: 'section[data-smart-pdp-scroll-section][id$="-overview"]' },
        { id: 'product_story_included', name: 'What Is Included', selector: 'section[data-smart-pdp-scroll-section][id$="-included"]' },
        { id: 'product_story_compare', name: 'Model Comparison', selector: 'section[data-smart-pdp-scroll-section][id$="-compare"]' },
        { id: 'product_story_software', name: 'Software Experience', selector: 'section[data-smart-pdp-scroll-section][id$="-software"]' },
        { id: 'product_story_business', name: 'Business Calculator', selector: 'section[data-smart-pdp-scroll-section][id$="-business"]' },
        { id: 'product_story_reviews', name: 'Customer Reviews', selector: 'section[data-smart-pdp-scroll-section][id$="-reviews"]' },
        { id: 'product_story_details', name: 'Product Details', selector: 'section[data-smart-pdp-scroll-section][id$="-details"]' },
        { id: 'product_detail_tabs', name: 'Product Details', selector: '[id^="shopify-section-"][id*="__smart_pdp_detail_tabs_"]' }
      ];
    }

    return [];
  }

  function firstVisibleElement(selector) {
    var elements;

    try {
      elements = document.querySelectorAll(selector);
    } catch (error) {
      return null;
    }

    for (var i = 0; i < elements.length; i += 1) {
      var rect = elements[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return elements[i];
    }

    return null;
  }

  function visibleMetrics(element) {
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var visibleTop = Math.max(0, rect.top);
    var visibleBottom = Math.min(viewportHeight, rect.bottom);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var elementHeight = Math.max(0, rect.height);

    return {
      visibleHeight: visibleHeight,
      elementHeight: elementHeight,
      ratio: elementHeight > 0 ? Math.min(1, visibleHeight / elementHeight) : 0
    };
  }

  function minimumVisibleHeight(elementHeight) {
    return Math.min(elementHeight, Math.min(200, Math.max(80, elementHeight * 0.5)));
  }

  function bindSectionViews() {
    if (typeof window.IntersectionObserver !== 'function') return;

    var definitions = sectionDefinitions();
    if (!definitions.length) return;

    var states = [];
    var stateByElement = new Map();
    var observed = {};
    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = stateByElement.get(entry.target);
        if (!state || seen[state.definition.id]) return;

        var metrics = visibleMetrics(entry.target);
        var qualifies = entry.isIntersecting &&
          metrics.visibleHeight >= minimumVisibleHeight(metrics.elementHeight);

        if (!qualifies) {
          if (state.timer) window.clearTimeout(state.timer);
          state.timer = null;
          return;
        }

        if (state.timer) return;
        state.timer = window.setTimeout(function () {
          state.timer = null;
          var current = visibleMetrics(entry.target);
          if (current.visibleHeight < minimumVisibleHeight(current.elementHeight)) return;

          seen[state.definition.id] = true;
          emit('section_view', trackingPayload({
            section_id: state.definition.id,
            section_name: state.definition.name,
            section_order: state.order,
            visible_ratio: Number(current.ratio.toFixed(2)),
            visible_height: Math.round(current.visibleHeight),
            view_threshold_ms: SECTION_VIEW_MIN_MS
          }), state.definition.id);
          observer.unobserve(entry.target);
        }, SECTION_VIEW_MIN_MS);
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });

    function registerAvailableSections() {
      definitions.forEach(function (definition, index) {
        if (observed[definition.id] || seen[definition.id]) return;

        var element = firstVisibleElement(definition.selector);
        if (!element) return;

        var state = {
          definition: definition,
          element: element,
          order: index + 1,
          timer: null
        };
        observed[definition.id] = true;
        states.push(state);
        stateByElement.set(element, state);
        observer.observe(element);
      });
    }

    registerAvailableSections();
    [1000, 3000, 6000].forEach(function (delay) {
      window.setTimeout(registerAvailableSections, delay);
    });

    window.__smart360SectionViewStates = states;
  }

  function bindCollectionCardViews() {
    if (pageType() !== 'collection' || typeof window.IntersectionObserver !== 'function') return;

    var grid = document.querySelector('#CollectionProductGrid');
    if (!grid) return;

    var observed = new WeakSet();
    var states = new WeakMap();
    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        var state = states.get(card);
        if (!state || seen[state.key]) return;

        if (!entry.isIntersecting || entry.intersectionRatio < CARD_VIEW_MIN_RATIO) {
          if (state.timer) window.clearTimeout(state.timer);
          state.timer = null;
          return;
        }

        if (state.timer) return;
        state.timer = window.setTimeout(function () {
          state.timer = null;
          var rect = card.getBoundingClientRect();
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
          var visibleHeight = Math.max(0, Math.min(viewportHeight, rect.bottom) - Math.max(0, rect.top));
          var visibleRatio = rect.height > 0 ? visibleHeight / rect.height : 0;
          if (visibleRatio < CARD_VIEW_MIN_RATIO) return;

          seen[state.key] = true;
          emit('collection_card_view', cardEventPayload(card, {
            visible_ratio: Number(visibleRatio.toFixed(2)),
            view_threshold_ms: CARD_VIEW_MIN_MS
          }), state.key);
          observer.unobserve(card);
        }, CARD_VIEW_MIN_MS);
      });
    }, { threshold: [0, CARD_VIEW_MIN_RATIO, 0.75, 1] });

    function registerCards() {
      grid.querySelectorAll('[data-smart-track-card="true"]').forEach(function (card) {
        if (observed.has(card)) return;
        var item = cardItem(card);
        if (!item.item_id) return;

        var key = item.item_id + ':' + item.index;
        observed.add(card);
        states.set(card, { key: key, timer: null });
        observer.observe(card);
      });
    }

    registerCards();
    if (typeof window.MutationObserver === 'function') {
      var mutationObserver = new MutationObserver(registerCards);
      mutationObserver.observe(grid, { childList: true, subtree: true });
      window.__smart360CollectionCardMutationObserver = mutationObserver;
    }

    window.__smart360CollectionCardObserver = observer;
  }

  function bindViewportTracking() {
    bindScrollDepth();
    bindSectionViews();
    bindCollectionCardViews();
  }

  function onClick(event) {
    if (!event.isTrusted) return;
    var path = eventPath(event);

    handleContact(path);
    handleFinancing(path);
    handleVariant(path);
    handleGallery(path);
    handleProductVideo(path);
    handleProductDetailNavigation(path);
    handleProductCta(path);
    handleInfo(path);
    handleCollectionQuickAdd(path);
    handleSelectItem(path);
  }

  window.addEventListener('click', onClick, true);
  window.addEventListener('change', function (event) {
    handleVariantChange(event);
    handleProductEstimatorChange(event);
  }, true);
  window.addEventListener('submit', function (event) {
    handleCollectionQuickAddSubmit(event);
    handleProductPurchaseSubmit(event);
  }, true);
  document.addEventListener('smart360:cart-add-result', handleCartAddResult, true);
  bindViewportTracking();
})();
